export default (function () {
  return {
    useConfig: process.env.VUE_APP_ENV,
    showKpiArea: true,
    showUpsIntegration: true,
    additionalConfig: {
      'production': {
        apiServerUrl: 'https://headwear.thecamels.pl/',
        showWarehouseBoxesUI: true,
        showHafciarniaIntegration: true,
        hafciarniaUrl: 'https://hafciarnia.thecamels.pl/',
        sewingRoomUrl: 'https://szwalnia.thecamels.pl/',
        offerProcessingTimeID: 2,
        customerPanelSearch: {
          typeTagID: 2,
          categories: {
            category1: 3,
            category2: 4,
            category3: 9,
            category4: 8
          }
        }
      },
      'staging': {
        apiServerUrl: 'https://headwear.the-dev.org/',
        showWarehouseBoxesUI: true,
        showHafciarniaIntegration: true,
        hafciarniaUrl: 'https://hafciarnia.the-dev.org/',
        sewingRoomUrl: 'https://szwalnia.the-dev.org/',
        offerProcessingTimeID: 2,
        customerPanelSearch: {
          typeTagID: 2,
          categories: {
            category1: 1,
            category2: 3,
            category3: 6,
            category4: 7
          }
        }
      },
      'development': {
        apiServerUrl: 'https://headwear2.the-dev.org/',
        showWarehouseBoxesUI: true,
        showHafciarniaIntegration: true,
        hafciarniaUrl: 'https://hafciarnia2.the-dev.org/',
        sewingRoomUrl: 'https://szwalnia2.the-dev.org/',
        offerProcessingTimeID: 2,
        customerPanelSearch: {
          typeTagID: 2,
          categories: {
            category1: 1,
            category2: 3,
            category3: 6,
            category4: 7
          }
        }
      }
    }
  }
})();
